/* eslint-disable no-unused-vars */
import { useQuery, useMutation } from "react-query";
import {
	get_faq_categories_api,
	add_faq_category_api,
	update_faq_category_api,
	delete_faq_category_api,
	get_faqs_api,
	add_faq_api,
	update_faq_api,
	delete_faq_api,
} from "../services/faq";

export const useGetFaqCategories = (payload) =>
	useQuery(["getFaqCategories", payload], () =>
		get_faq_categories_api(payload)
	);

export const useAddFaqCategory = () =>
	useMutation("addFaqCategory", (body) => add_faq_category_api(body));

export const useUpdateFaqCategory = () =>
	useMutation("updateFaqCategory", (body) => update_faq_category_api(body));

export const useDeleteFaqCategory = () =>
	useMutation("deleteFaqCategory", (body) => delete_faq_category_api(body));

export const useGetFaqs = (payload) =>
	useQuery(["getFaqs", payload], () => get_faqs_api(payload));

export const useAddFaq = () =>
	useMutation("addFaq", (body) => add_faq_api(body));

export const useUpdateFaq = () =>
	useMutation("updateFaq", (body) => update_faq_api(body));

export const useDeleteFaq = () =>
	useMutation("deleteFaq", (body) => delete_faq_api(body));
